import task from './task'

const apiBusinesses = {
  'get-list': {
    method: 'post',
    url: '/ws-admincp/business/list'
  },
  getById: {
    method: 'get',
    url: '/ws-admincp/business/ID'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/business'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/business/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/business/restore'
  },
  add: {
    method: 'post',
    url: '/ws-admincp/business'
  },
  edit: {
    method: 'put',
    url: '/ws-admincp/business/ID'
  },
  select: {
    method: 'get',
    url: '/ws-admincp/business/find?key=KEY'
  },
  selectByNodeTpe: {
    method: 'get',
    url: '/ws-admincp/business/find?key=KEY&nodeType=NODE_TYPE'
  },
  default: {
    method: 'get',
    url: '/ws-admincp/business/create-default'
  },
  getByNodeType: {
    method: 'get',
    url: '/ws-admincp/business/by-node-type?id=ID'
  },
  getByNodeTypeWithTranporation: {
    method: 'get',
    url: '/ws-admincp/business/by-node-type?id=ID&transporation=TRANSPORATION'
  }
}

export default {
  ...apiBusinesses,
  task
}
